export const URL = "http://72550e6e.ngrok.io"
export const WSS = "ws://185.251.90.101:8080"